import { Box, Typography } from '@mui/material';
import { ArrowUpIcon } from 'assets/icons';
import { ChartOptions } from 'chart.js';
import { WhiteBgCard } from 'components';
import React from 'react';
import { Bar } from 'react-chartjs-2';

const ChartLabels = () => (
  <div className="row mx-0 gx-3">
    <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
      <Box
        sx={{
          mr: 1,
          width: 6,
          height: 6,
          backgroundColor: '#9092BE',
          borderRadius: 5,
        }}
      />

      <Typography variant="body2" sx={{ mr: 1 }}>
        Sessions
      </Typography>
      <Typography variant="h6">
        $0
      </Typography>
    </div>

    <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
      <Box
        sx={{
          mr: 1,
          width: 6,
          height: 6,
          backgroundColor: '#F7C85C',
          borderRadius: 5,
        }}
      />

      <Typography variant="body2" sx={{ mr: 1 }}>
        Profile
      </Typography>
      <Typography variant="h6">
        $0
      </Typography>
    </div>

    <div className="col-auto d-flex align-items-center mb-2 mb-sm-0">
      <Box
        sx={{
          mr: 1,
          width: 6,
          height: 6,
          backgroundColor: '#B5E69A',
          borderRadius: 5,
        }}
      />

      <Typography variant="body2" sx={{ mr: 1 }}>
        Groups
      </Typography>
      <Typography variant="h6">
        $0
      </Typography>
    </div>
  </div>
);

export default function WalletChart() {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [{
      label: 'Session',
      backgroundColor: '#9092BE',
      data: [],
    }, {
      label: 'Profile',
      backgroundColor: '#FFD36D',
      data: [],
    }, {
      label: 'Groups',
      backgroundColor: '#B5E69A',
      data: [],
    }],
  };

  const options: ChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="col-12 col-lg-7 mb-4">
      <WhiteBgCard>
        <div className="row mb-4 align-items-start">
          <div className="col-12 col-md-auto">
            <div className="d-flex flex-column">
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Earnings
              </Typography>
              <div className="d-flex align-items-center">
                <Typography variant="h4" sx={{ color: 'text.primary', pr: 2 }}>
                  $0
                </Typography>
                <Box
                  sx={{
                    backgroundColor: 'secondary.light', py: 1, px: 1.75, borderRadius: 1.5,
                  }}
                  className="d-flex align-items-center"
                >
                  <ArrowUpIcon sx={{ color: 'secondary.dark', fontSize: 16, mr: 1 }} />

                  <Typography sx={{ color: 'secondary.dark' }} variant="body2">
                    $0
                  </Typography>
                </Box>
              </div>
            </div>

          </div>
          <div className="col d-none d-md-flex justify-content-md-end">

            <ChartLabels />

          </div>
        </div>
        <Bar data={data} options={options} />

        <div className="mt-4 d-flex flex-wrap d-md-none">
          <ChartLabels />
        </div>

      </WhiteBgCard>
    </div>
  );
}
